import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { API } from "aws-amplify";
import IconTableDown from "../../Resources/svg/Icons/IconTableDown";
import Flags from "./Flags";

import { addClient, modalAside } from "../../Store/simulate/actions";
import { decryptEstandar } from "../../Utils/CryptographyUtils";
import { formatNumber, handleState } from "../../Utils/utils";
import moment from "moment";
import { getTitleCase } from "../../Utils/simulaciones/simulaciones";
import Loading from "../loading";
import Tooltips from "./Tooltips";
import IconOptions from "../../Resources/svg/Icons/IconOptions";
import IconCloseOptions from "../../Resources/svg/Icons/IconCloseOptions";
import { meses } from "../../Utils/aprobaciones/month";

const CardTablaTmp = ({
  data,
  codProd,
  setModalData,
  handleOpenModalAttach,
  variant,
  reenviarEmail,
}: any) => {
  const [linkPdf, setLinkPdf] = useState("");
  const elem: any = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const asesor = useSelector((state: any) =>
    decryptEstandar(state.login.username)
  );
  const [isLoading, setIsLoading] = useState<any>(false);

  const [collapse, setCollapse] = useState<any>(false);
  const [showoptions, setShowOptions] = useState<any>(false);

  const {
    estado,
    idCotizacion,
    numCotizacion,
    datosCliente: { nombres, documento, portafolio },
    datosCotizacion: {
      prima,
      tasa,
      moneda,
      primaBase,
      primaAhorro,
      vencimiento,
    },
    descripcionEstado,
  }: any = data || null;
  const numPoliza = data.datosEmision ? data.datosEmision.numPoliza : "";

  const onClickCotizar = (item: any) => {
    if (codProd === "IG") {
      if (item.estado !== "firmado" && item.estado !== "revision") {
        setModalData(item);
        dispatch(modalAside(true));
      } else {
        history.push({
          pathname: "/cotizaciones/aprobacion",
          state: item,
          ri: false,
        });
      }
    } else if (codProd === "AS" || codProd === "UC") {
      if (item.estado !== "firmado") {
        setModalData(item);
        dispatch(modalAside(true));
      } else {
        history.push({
          pathname: "/cotizaciones/aprobacion",
          state: item,
          ri: false,
        });
      }
    } else {
      dispatch(addClient(item));
      history.push("/cotizaciones/verificacion");
    }
  };

  const handleCardStateTable = () => {
    setCollapse((c: any) => !c);
  };

  const generatePdfSimulate = async (data: any) => {
    setIsLoading(true);
    const response = await API.get(
      "api-rentas",
      "/generate-pdf/" + data.idCotizacion,
      data.idCotizacion
    );

    if (response.status) {
      setTimeout(() => {
        setIsLoading(false);
      }, 4000);
      setLinkPdf(response.data);
    } else {
      console.log(response.message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (linkPdf) {
      elem.current.click();
    }
  }, [linkPdf]);

  const convertNames = nombres.toLowerCase();

  const availableBottons = (estado: any) => {
    return estado !== "Vencida" && ["AS", "IG", "UC"].includes(codProd);
  };

  const hanldeOpenMenu = () => {
    setShowOptions(true);
    document.body.style.overflow = "hidden";
  };

  const hanldeCloseMenuCard = () => {
    setShowOptions(false);
    document.body.style.overflow = "auto";
  };

  const variantes = ["cotizador", "aprobacion"];

  const validationDate = vencimiento ? vencimiento.split("-")[1] - 1 : "-";

  return (
    <div className="card-table">
      <a
        style={{ display: "none" }}
        target="_blank"
        rel="noopener noreferrer"
        href={linkPdf}
        ref={elem}
      />
      <div className="flag-state-info">
        <Flags variant={estado}>{handleState(estado)}</Flags>
        <Tooltips text={descripcionEstado} />
      </div>
      {variantes.includes(variant) ? (
        <div className={`card-table__icon`} onClick={hanldeOpenMenu}>
          <IconOptions />
        </div>
      ) : (
        <div className={`card-table__icon`} onClick={handleCardStateTable}>
          <IconTableDown className={`${collapse ? "up" : "down"}`} />
        </div>
      )}
      <div className="card-table__box">
        <div className="card-table__description">Nº de cotización:</div>
        <div className="card-table__data">{numCotizacion}</div>
        <div className="card-table__description">Contratante:</div>
        <div className="card-table__data">{getTitleCase(convertNames)}</div>
        <div className="card-table__description">DNI/CE:</div>
        <div className="card-table__data">{documento}</div>
        {collapse && (
          <>
            <div className="card-table__description">Vencimiento:</div>
            <div className="card-table__data">
              {vencimiento
                ? // ? moment(vencimiento, "DD-MM-YYYY").locale("es").format("ll")
                  `${vencimiento.split("-")[0]} ${meses[validationDate]} ${
                    vencimiento.split("-")[2]
                  }`
                : "-"}
            </div>
            <div className="card-table__description">Prima comercial:</div>
            <div className="card-table__data">
              {moneda && moneda.simbolo} {formatNumber.new(prima)}
            </div>

            {codProd == "IG" ? (
              <>
                <div className="card-table__description">Portafolio:</div>
                <div className="card-table__data">
                  {portafolio ? portafolio : ""}
                </div>
              </>
            ) : (
              tasa !== null && (
                <>
                  <div className="card-table__description">Tasa:</div>
                  <div className="card-table__data">{tasa}%</div>
                </>
              )
            )}
            <div className="card-table__description">Póliza:</div>
            {numPoliza ? numPoliza : "-"}
          </>
        )}
        {variantes.includes(variant) && (
          <div className="card-table__options" onClick={handleCardStateTable}>
            {collapse ? "Mostrar menos" : "Mostrar más"}
            <IconTableDown className={`${collapse ? "up" : "down"}`} />
          </div>
        )}
      </div>
      <div className="menu">
        <div className={`menu__box ${showoptions ? "open-options" : ""}`}>
          <div className="header-card">
            <div className="header-card__title">
              Más opciones{" "}
              <span onClick={hanldeCloseMenuCard}>
                <IconCloseOptions />
              </span>
            </div>
          </div>
          <div className="menu__options">
            {estado === "porFirmar" && variant === "cotizador" && (
              <div
                className="menu__buttons"
                onClick={() => reenviarEmail(data)}
              >
                <div>Reenviar</div>
              </div>
            )}

            {estado === "firmado" && (
              <div
                className="menu__buttons"
                onClick={() => handleOpenModalAttach(data)}
              >
                <div>Adjuntar</div>
              </div>
            )}

            <div
              className="menu__buttons"
              onClick={() => generatePdfSimulate({ ...data, asesor })}
            >
              <div>Descargar</div>
            </div>

            <div className="menu__buttons" onClick={() => onClickCotizar(data)}>
              Revisar
            </div>
          </div>
        </div>
        <div
          className={`menu__background ${showoptions ? "open-options" : ""}`}
        ></div>
      </div>

      {isLoading && <Loading />}
    </div>
  );
};

export default CardTablaTmp;
